var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"id":"virtualcard"}},[_c('div',{staticClass:"text-center"},[_c('base-btn',{attrs:{"to":{ name: 'beranda' }}},[_vm._v(" Riva ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }